import { useEffect } from 'react';
import { gtmService } from '@/util/gtm-service';

export function useGtm() {
  useEffect(() => {
    gtmService.init();
  }, []);
}
